import { IState } from '../../../store';
import { selectOfferAgent } from '../selectOfferAgent';

export const selectAgentAvatarUrl = (state: IState): string | null => {
  const agent = selectOfferAgent(state);

  return agent?.absoluteAvatarUrl || null;
};
